import React from 'react'
import BreathingBadgeDot from '../../features/support-ticket/components/BreathingBadgeDot'

export default function SidebarFooterLinks({ onSupportNavigate, isSupportActive = false, onLogout, hasSupportIndicator = false }) {
  return (
    <div className="sidebar-footer-sticky">
      <div className="sidebar-footer-links">
        <button
          type="button"
          className={`menu-btn subtle ${isSupportActive ? 'active' : ''}`}
          onClick={onSupportNavigate}
        >
          <span className="menu-icon-wrap">
            <span className="material-symbols-outlined">support_agent</span>
            {hasSupportIndicator ? (
              <BreathingBadgeDot
                color="rose"
                className="absolute -top-1 -right-1"
                aria-label="New support ticket activity"
              />
            ) : null}
          </span>
          <span>Support</span>
        </button>
        <button type="button" className="menu-btn subtle" onClick={onLogout}>
          <span className="material-symbols-outlined">logout</span>
          <span>Logout</span>
        </button>
      </div>
    </div>
  )
}
